import type { Analytics } from '@segment/analytics-next'
import { useCookies } from '@/composables/useCookies'

const TIKTOK_CLICK_ID_COOKIE_NAME = 'ttclid' as const

export const setupTiktok = (analytics: Analytics): void => {
  const cookies = useCookies()

  const traits: Record<string, string> = {}
  const ttclid = cookies.get(TIKTOK_CLICK_ID_COOKIE_NAME)

  if (ttclid) {
    traits.ttclid = ttclid
  }

  analytics.identify(traits)
}
